import React from 'react';
import { ChildrenProps } from '../interfaces/childrenProps';

export const IELink = (props: ChildrenProps): JSX.Element => {
  if (window.navigator.userAgent.includes('Trident') || window.navigator.userAgent.includes('Edge')) {
    return <span role="link">{props.children}</span>;
  }

  return <>{props.children}</>;
};
